module.exports = __webpack_public_path__ + "img/f8d3239.png";